<template>
  <div class="submit-buttons">
    <div class="d-flex align-items-center">
      <save-button
        :variant="variant"
        :btn-text="submitText"
        :show-confettis="showConfettis"
        :animate-confettis="animateConfettis"
        :submit-btn-class="submitBtnClass"
        :is-loading="isLoading"
        :is-submit-disabled="isSubmitDisabled"
        :type="type"
        @save="$emit('save', notifySubscribers)"
      />
      <b-button
        v-if="!hideCancel"
        variant="link"
        class="border-0 text-medium text-secondary"
        size="sm"
        pill
        @click="$emit('cancel', $event)"
        >{{ cancelText }}
      </b-button>
      <div v-if="showNotifySubscribers" class="pl-3 text-medium text-secondary">
        <b-form-checkbox v-model="notifySubscribers" class="py-1" size="sm"
          >Notify subscribers</b-form-checkbox
        >
      </div>
    </div>
    <!-- @slot If you want to place some element on other side of buttons -->
    <slot></slot>
  </div>
</template>

<script>
import SaveButton from '@/components/SaveButton.vue'
import { BButton, BFormCheckbox } from 'bootstrap-vue'

/**
 * This component export a submit bar containing save and cancel button

 emits

 - save - emitted on click of save button
 - cancel - emitted on click of cancel button
 */
export default {
  name: 'SubmitButtons',
  props: {
    /**
    custom name for submit button
     */
    submitText: {
      default: 'Save',
      type: String
    },
    /**
    custom name for cancel button
     */
    cancelText: {
      default: 'Cancel',
      type: String
    },
    hideCancel: {
      default: false,
      type: Boolean
    },
    showNotifySubscribers: {
      default: false,
      type: Boolean
    },
    /**
    Attach data-attr for confettis.
    It is used when you want to show confettis on click of submit button
    */
    showConfettis: {
      default: false,
      type: Boolean
    },
    animateConfettis: {
      default: false,
      type: Boolean
    },
    isLoading: Boolean,
    variant: String, // This is variant of submit button
    isSubmitDisabled: {
      default: false,
      type: Boolean
    },
    submitBtnClass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  components: {
    BButton,
    BFormCheckbox,
    SaveButton
  },
  data() {
    return {
      // This is getting used in parent components as well
      notifySubscribers: false
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-buttons {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 4px;
}
</style>
